import React from "react"
import { Controller, Control } from "react-hook-form"
import { graphql } from "gatsby"

export const query = graphql`
  fragment FormInputDropdown on DatoCmsFormInputDropdown {
    id
    options
    name
    label
    required
    model {
      apiKey
    }
  }
`

export interface FromInputSelect extends Queries.FormInputDropdownFragment {
  control: Control
}

type FormInputSelectProps = Omit<FromInputSelect, "id">

const FormInputDropdown = ({
  control,
  name,
  label,
  options,
  required = false,
}: FormInputSelectProps) => {
  const allOptions: string[] = JSON.parse(options)

  const generateSingleOptions = () => {
    return allOptions.map((option: string) => {
      return (
        <option key={option} value={option}>
          {option}
        </option>
      )
    })
  }

  return (
    <div className="o-form__item">
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange } }) => (
          <select
            name={name}
            id={name}
            className="c-form__select"
            onChange={onChange}
            required={required}
            defaultValue={""}
          >
            <option disabled value="">
              {label}
            </option>
            {generateSingleOptions()})
          </select>
        )}
      />
    </div>
  )
}

export default FormInputDropdown
